export default "__VITE_ASSET__238b6d74__"